'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'ufo-beam';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e048';
var svgPathData = ['M30.6 518.1l39.5 27.3 13.7-19.7 72-104 13.7-19.7-39.5-27.3-13.7 19.7-72 104-13.7 19.7zm97.4-361s47.1 50.9 160 50.9 160-50.9 160-50.9c0-14.1-1.6-27.7-4.5-40.8-17-75.9-80.2-132.2-155.5-132.2S149.4 40.4 132.5 116.2c-2.9 13.1-4.5 26.8-4.5 40.8zM406.6 401.9l13.7 19.7 72 104 13.7 19.7 39.5-27.3-13.7-19.7-72-104-13.7-19.7-39.5 27.3z', 'M288 208c112.9 0 160-50.9 160-50.9 0-14.1-1.6-27.7-4.5-40.8 79.7 22.8 132.5 62.5 132.5 107.8 0 70.7-128.9 128-288 128S0 294.7 0 224c0-45.2 52.8-85 132.5-107.8-2.9 13.1-4.5 26.8-4.5 40.8 0 0 47.1 50.9 160 50.9zm0 30.1L254.1 272 288 305.9 321.9 272 288 238.1zM153.9 240L120 206.1 86.1 240 120 273.9 153.9 240zM456 206.1L422.1 240 456 273.9 489.9 240 456 206.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUfoBeam = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;